import MarketingAccountOnboardingView from './MarketingAccountOnboardingView';

export default MarketingAccountOnboardingView;
